import React from 'react';
import './otherCSS/UnderwaterCamera.css';

const UnderwaterCamera = () => {
    return (
        <div className="underwater-camera-container">
            <div className="underwater-camera-content">
                <div className="hero-section">
                    <h1 className="page-title">Underwater Camera</h1>
                </div>

                <div className="video-section">
                    <div className="video-container" style={{ marginBottom: '20px' }}>
                        <div style={{
                            position: 'relative',
                            paddingBottom: '56.25%', /* 16:9 aspect ratio */
                            height: 0,
                            overflow: 'hidden',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            marginBottom: '10px'
                        }}>
                            <iframe 
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    border: 'none'
                                }}
                                src="https://www.youtube.com/embed/oBTGY6Ax870?autoplay=0&rel=0"
                                title="Wahoo Bay Underwater Camera - Live Feed"
                                credentialless="true"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>

                <div className="content-section">
                    <div className="text-content">
                        <p className="main-description">
                            Watch marine life in real-time at Wahoo Bay through our underwater camera system. 
                            This live feed provides an immersive experience to observe marine life, coral, and other 
                            marine creatures in their natural habitat while supporting marine conservation education.
                        </p>
                    </div>
                </div>

                <div className="camera-info-section">
                    <h2 className="section-title">What You'll See</h2>
                    <div className="info-grid">
                        <div className="info-item">
                            <div className="info-icon">🐠</div>
                            <h3>Marine Life</h3>
                            <p>Observe marine life, coral, and other creatures in their natural habitat</p>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">🌊</div>
                            <h3>Live Habitat</h3>
                            <p>Real-time views of our restored marine ecosystem and conservation efforts</p>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">📊</div>
                            <h3>Educational Value</h3>
                            <p>Perfect for classroom observation and marine biology education</p>
                        </div>
                    </div>
                </div>

                <div className="features-section">
                    <div className="features-card">
                        <h2 className="features-title">Camera Features</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <span className="feature-icon">📹</span>
                                <div className="feature-content">
                                    <h4>24/7 Live Stream</h4>
                                    <p>Continuous underwater footage available anytime</p>
                                </div>
                            </div>
                            
                            <div className="feature-item">
                                <span className="feature-icon">🎥</span>
                                <div className="feature-content">
                                    <h4>High Definition Quality</h4>
                                    <p>Crystal clear underwater viewing experience</p>
                                </div>
                            </div>
                            
                            <div className="feature-item">
                                <span className="feature-icon">🌅</span>
                                <div className="feature-content">
                                    <h4>Variable Lighting</h4>
                                    <p>Experience the underwater world at different times of day</p>
                                </div>
                            </div>
                            
                            <div className="feature-item">
                                <span className="feature-icon">📚</span>
                                <div className="feature-content">
                                    <h4>Educational Tool</h4>
                                    <p>Perfect for remote learning and marine science education</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="educational-use">
                    <h2 className="section-title">Educational Applications</h2>
                    <div className="edu-grid">
                        <div className="edu-card">
                            <h3 className="edu-title">Classroom Integration</h3>
                            <p className="edu-description">
                                Use our live camera feed for real-time marine biology lessons and 
                                virtual field trips to supplement classroom learning.
                            </p>
                        </div>
                        
                        <div className="edu-card">
                            <h3 className="edu-title">Species Observation</h3>
                            <p className="edu-description">
                                Students can observe and document marine species behavior patterns
                                and habitat interactions over time. <a href="https://docs.google.com/spreadsheets/d/1Git0Chs3pnEDngCVfDJmQ7noGM90h7uCu3AKecNgiOQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer" style={{color: '#0088d6', textDecoration: 'underline'}}>View our confirmed species list</a>.
                            </p>
                        </div>
                        
                        <div className="edu-card">
                            <h3 className="edu-title">Conservation Awareness</h3>
                            <p className="edu-description">
                                Demonstrate the importance of marine conservation through direct 
                                observation of restored ecosystems.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="call-to-action">
                    <div className="cta-card">
                        <h2 className="cta-title">AI Fish Identification</h2>
                        <p className="cta-description">
                            Contact us if you would like to get involved in helping build our AI fish identification model.
                        </p>
                        <div className="cta-buttons">
                            <a href="/pages/contact-us" className="cta-button primary">
                                Contact Us
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnderwaterCamera;
